import React from "react";
import ProductModal from "src/features/product-modal/ProductModal";
import Responsive from "src/shared/components/Responsive";
import CombinedProductModal from "../combined-product/components/CombinedProductModal";
import "./Home.scss";

const MainContainer = () => {
  return (
    <div>
      <Responsive
        desktop={() => import("./components/Desktop")}
        mobile={() => import("./components/Mobile")}
      >
        {(Component: any) => <Component />}
      </Responsive>

      <ProductModal />
      <CombinedProductModal />
    </div>
  );
};

export default MainContainer;
